<template>
  <div id="app">
    <b-container>
    <b-navbar class="d-flex"  id="nav">
     <router-link class="ml-auto" to="/">About</router-link>
      <router-link to="/articles">Articles</router-link>
      <router-link to="/projects">Projects</router-link>
     
      
    </b-navbar>
    <router-view />
    </b-container>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "./components/Footer.vue"
export default {

  components:{
Footer,
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  
  
 
}

#nav {
 
  padding: 50px;
  
  a {
    
    color: #2c3e50;
    text-decoration-line: none;
    margin-left: 40px;
    font-size: 20px;

  }
  
}
</style>
